<template>
  <div @click="isDo()"
    class="d2-layout-header-aside-group"
    :style="styleLayoutMainGroup"
    :class="{grayMode: grayActive}">
    <!-- 半透明遮罩 -->
    <div class="d2-layout-header-aside-mask"></div>
    <!-- 主体内容 -->
    <div class="d2-layout-header-aside-content" flex="dir:top">
      <!-- 顶栏 -->
      <div
        class="d2-theme-header"
        :style="{
          opacity: this.searchActive ? 0.5 : 1
        }"
        flex-box="0"
        flex>
        <div class="logo-group" :style="{width: asideCollapse ? asideWidthCollapse : asideWidth}" flex-box="0">
<!--          <img v-if="asideCollapse" :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/logo-only-1.png`">-->
          <h2 v-if="asideCollapse" style="font-size: 16px; font-weight: bold; text-align: center; color: #F2F6FC;margin-top: 5px"></h2>
<!--          <h1 v-else style="font-size: 36px; font-weight: bold; text-align: center; color: #F2F6FC; margin-top: 5px" >泰德科技园</h1>-->
          <h1 v-else style="font-size: 24px; font-weight: unset; text-align: center; color: #F2F6FC; margin-top: 10px" >预 付 费 云 平 台</h1>
        </div>
        <div class="toggle-aside-btn" @click="handleToggleAside" flex-box="0">
          <d2-icon name="bars"/>
        </div>
        <d2-menu-header flex-box="1"/>
        <!-- 顶栏右侧 -->
        <div class="d2-header-right" flex-box="0">
          <!-- 如果你只想在开发环境显示这个按钮请添加 v-if="$env === 'development'" -->
<!--          <select-area></select-area>-->
          <el-image
            style="width: 25px; height: 25px"
            :src="`${$baseUrl}image/gh_db977648d2d8_860.jpg`"
            :preview-src-list="[`${$baseUrl}image/gh_db977648d2d8_860.jpg`]">
          </el-image>
<!--          <d2-header-search @click="handleSearchClick"/>-->
          <d2-header-log ref="headerLog"/>
          <d2-header-fullscreen/>
<!--          <d2-header-theme/>-->
<!--          <d2-header-size/>-->
<!--          <d2-header-locales/>-->
<!--          <d2-header-color/>-->
          <d2-header-user  ref="user_logoff"/>
        </div>
      </div>
      <!-- 下面 主体 -->
      <div class="d2-theme-container" flex-box="1" flex>
        <!-- 主体 侧边栏 -->
        <div
          flex-box="0"
          ref="aside"
          class="d2-theme-container-aside"
          :style="{
            width: asideCollapse ? asideWidthCollapse : asideWidth,
            opacity: this.searchActive ? 0.5 : 1
          }">
          <d2-menu-side/>
        </div>
        <!-- 主体 -->
        <div class="d2-theme-container-main" flex-box="1" flex>
          <!-- 搜索 -->
          <transition name="fade-scale">
            <div v-if="searchActive" class="d2-theme-container-main-layer" flex>
              <d2-panel-search
                ref="panelSearch"
                @close="searchPanelClose"/>
            </div>
          </transition>
          <!-- 内容 -->
          <transition name="fade-scale">
            <div v-if="!searchActive" class="d2-theme-container-main-layer" flex="dir:top">
              <!-- tab -->
              <div class="d2-theme-container-main-header" flex-box="0">
                <d2-tabs/>
              </div>
              <!-- 页面 -->
              <div class="d2-theme-container-main-body" flex-box="1">
                <transition :name="transitionActive ? 'fade-transverse' : ''">
                  <keep-alive :include="keepAlive">
                    <router-view/>
                  </keep-alive>
                </transition>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/libs/util.js'
import {findRoomUser} from '@/api/equipment/water'
import d2MenuSide from './components/menu-side'
import d2MenuHeader from './components/menu-header'
import d2Tabs from './components/tabs'
import d2HeaderFullscreen from './components/header-fullscreen'
// import d2HeaderLocales from './components/header-locales'
import d2HeaderSearch from './components/header-search'
// import d2HeaderSize from './components/header-size'
import d2HeaderTheme from './components/header-theme'
import d2HeaderUser from './components/header-user'
import d2HeaderLog from './components/header-log'
// import d2HeaderColor from './components/header-color'
import {mapActions, mapGetters, mapState} from 'vuex'

import {getResourseByRoleIdTree} from '@/api/sys/sys_resourse'
import utils from '@/libs/util.ice'
import mixinSearch from './mixins/search'

export default {
  name: 'd2-layout-header-aside',
  mixins: [
    mixinSearch
  ],
  components: {
    d2MenuSide,
    d2MenuHeader,
    d2Tabs,
    d2HeaderFullscreen,
    // d2HeaderLocales,
    d2HeaderSearch,
    // d2HeaderSize,
    d2HeaderTheme,
    d2HeaderUser,
    d2HeaderLog,
    // d2HeaderColor
  },
  data () {
    return {
      roleId: null,
      // [侧边栏宽度] 正常状态
      asideWidth: '220px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '65px',
      lastTime: null, // 最后一次点击的时间
      currentTime: null, // 当前点击的时间
      timeOut: 4 * 60 * 60 * 1000 // 4 小时 = 4 * 60 * 60 * 1000 毫秒
      // timeOut: 10 * 1000 // 10 秒 = 10 * 1000 毫秒
    }
  },
  computed: {
    ...mapState('d2admin', {
      keepAlive: state => state.page.keepAlive,
      grayActive: state => state.gray.active,
      transitionActive: state => state.transition.active,
      asideCollapse: state => state.menu.asideCollapse
    }),
    ...mapGetters('d2admin', {
      themeActiveSetting: 'theme/activeSetting'
    }),
    /**
             * @description 最外层容器的背景图片样式
             */
    styleLayoutMainGroup () {
      return {
        ...this.themeActiveSetting.backgroundImage ? {
          backgroundImage: `url('${this.$baseUrl}${this.themeActiveSetting.backgroundImage}')`
        } : {}
      }
    }
  },
  created () {
    this.lastTime = new Date().getTime() // 网页第一次打开时，记录当前时间
  },
  mounted () {
    this.caidan()
    this.queryAreaAll()
    this.findWaterRoomUser()
    // window.addEventListener('beforeunload', e => this.$refs.user_logoff.timeOff())
  },
  methods: {
    ...mapActions('d2admin/menu', [
      'asideCollapseToggle'
    ]),
    /**
             * 接收点击切换侧边栏的按钮
             */
    findWaterRoomUser () {
      let query_water_room = util.cookies.get('query_water_room')
      if (query_water_room !== undefined) {
        this.mokuaiList = JSON.parse(query_water_room)
      } else {
        findRoomUser().then(res => {
          this.mokuaiList = res.success
          util.cookies.set('query_water_room', JSON.stringify(this.mokuaiList))
        }).catch(err => {
          // 删除cookie
          util.cookies.remove('token')
          util.cookies.remove('uuid')
          util.cookies.remove('areaid')
          util.cookies.remove('roleId')
          // 跳转路由
          this.$router.replace({
            name: 'login'
          })
        })
      }
    },
    handleToggleAside () {
      this.asideCollapseToggle()
    },
    queryAreaAll () {
      // findUserUnBind().then(function (res) {
      //     //  util("userunbind", JSON.stringify(res.success))
      //     util.cookies.set("userunbind", JSON.stringify(res.success))
      // }).catch(function (err) {
      //     console.error('err', err);
      // });
    },
    caidan () {
      // 设置侧边栏菜单
      this.roleId = util.cookies.get('roleId')
      getResourseByRoleIdTree({ roleId: this.roleId })
        .then(async res => {
          // console.log('权限权限权限——————————+++++'+JSON.stringify(res.data[0].children))
          this.$store.commit('d2admin/menu/asideSet', utils.recursiveMenuConfig(res.data[0].children))
        })
    },
    isDo () {
      this.currentTime = new Date().getTime() // 记录这次点击的时间
      if (this.currentTime - this.lastTime > this.timeOut) {
        this.$handleLoginExpired()
      } else {
        let a = this.lastTime
        this.lastTime = new Date().getTime() // 如果在10分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
      }
    }
  }
}
</script>

<style lang="scss">
// 注册主题
@import '~@/assets/style/theme/register.scss';
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/layout.vue"
}
</vue-filename-injector>
